import { render, staticRenderFns } from "./ActionsBar.vue?vue&type=template&id=5f04c154&scoped=true&"
import script from "./ActionsBar.vue?vue&type=script&lang=js&"
export * from "./ActionsBar.vue?vue&type=script&lang=js&"
import style0 from "./ActionsBar.vue?vue&type=style&index=0&id=5f04c154&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f04c154",
  null
  
)

export default component.exports